export class ReviewSearchCreatedEvent {
  constructor(public readonly reviewId: number) {}
}
